import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: 'input'  // Se aplica a TODOS los inputs
})
export class NoAutocompleteDirective implements OnInit {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    if (this.el.nativeElement.type !== 'hidden') {  // Solo excluimos los inputs hidden
      const element = this.el.nativeElement;
      
      // Previene autocompletado y datalist
      element.setAttribute('autocomplete', 'off');
      element.removeAttribute('list');  // Elimina cualquier conexión con datalist
      
  }
}
    
}